import { derived, writable } from 'svelte/store';
import { EmployerDashboardService } from '../lib/api/employer';

export interface EmployerPendingActionsState {
  pendingRequestsCount: number;
  pendingPaymentsCount: number;
  pendingPaymentsValue: number;
  loading: boolean;
  loaded: boolean;
}

const initialState: EmployerPendingActionsState = {
  pendingRequestsCount: 0,
  pendingPaymentsCount: 0,
  pendingPaymentsValue: 0,
  loading: false,
  loaded: false,
};

export const employerPendingActions = writable<EmployerPendingActionsState>(initialState);

export const hasEmployerPendingRequests = derived(
  employerPendingActions,
  ($state) => $state.pendingRequestsCount > 0
);

export const hasEmployerPendingPayments = derived(
  employerPendingActions,
  ($state) => $state.pendingPaymentsCount > 0 || $state.pendingPaymentsValue > 0
);

export function setEmployerPendingActions(
  pendingRequestsCount: number,
  pendingPaymentsCount: number,
  pendingPaymentsValue: number
): void {
  employerPendingActions.set({
    pendingRequestsCount,
    pendingPaymentsCount,
    pendingPaymentsValue,
    loading: false,
    loaded: true,
  });
}

export async function refreshEmployerPendingActions(): Promise<void> {
  employerPendingActions.update((state) => ({ ...state, loading: true }));

  try {
    const response = await EmployerDashboardService.getDashboard();
    if (response.success && response.data) {
      setEmployerPendingActions(
        response.data.pending_requests_count ?? 0,
        response.data.pending_payments_count ?? 0,
        response.data.pending_payments_value ?? 0
      );
      return;
    }
  } catch (error) {
    console.error('Failed to load employer pending action stats:', error);
  }

  employerPendingActions.update((state) => ({
    ...state,
    loading: false,
    loaded: true,
  }));
}

export function clearEmployerPendingActions(): void {
  employerPendingActions.set(initialState);
}
